<template>
<v-container fluid>
    <ParameterItemComponent @close="handleDataCloseOperacije($event)" :operationType="operationType"/>
    <ParameterTableComponent  v-if="operationType === undefined || operationType === null"/>
</v-container>
   

</template>

<script>
// @ is an alias to /src
import ParameterItemComponent from "@/components/ParameterItemComponent.vue";
import ParameterTableComponent from "@/components/ParameterTableComponent.vue";

export default {
  props: [
    "operationType"
  ],
  name: "parameter",
  components: {
    ParameterItemComponent,
    ParameterTableComponent
  },
  methods:{
    handleDataCloseOperacije: function (e) {
      this.$emit("close", e);
    },
  },
 watch: {
    operationType: function (val) {
      
    }
 }
};
</script>
           
<style scoped lang='scss'>
</style>
